import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { MenuItem, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdamsDocModel } from 'src/app/models/adams-doc-model';

@Component({
  selector: 'app-more-details',
  templateUrl: './more-details.component.html',
  styleUrls: ['./more-details.component.css']
})
export class MoreDetailsComponent implements OnInit {

  item: AdamsDocModel = {};
  showCopyMsg = false;
  shareDocPropItems: MenuItem[] = [];
  shareDocItems: MenuItem[] = [];

  constructor(public dialogRef: DynamicDialogRef, public config: DynamicDialogConfig,
    private clipboardApi: ClipboardService, private msgService: MessageService,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    this.item = this.config.data;
    this.shareDocPropItems = [
      {
        label: 'Open Properties in New Tab',
        icon: 'fa-solid fa-up-right-from-square',
        url: '/props/' + this.item.Id,
        target: '_blank'
      },
      {
        label: 'Copy Properties Link',
        icon: 'fa-regular fa-copy',
        command: () => this.copyPropertiesLink(),
      }
    ];
    this.shareDocItems = [
      {
        label: 'Copy Link',
        icon: 'fa-regular fa-copy',
        command: () => this.copyClipboard(),
      },
      {
        label: 'Download',
        icon: 'fa-solid fa-file-arrow-down',
        url: this.item.Url
      }
    ];
  }

  copyClipboard() {
    if (this.item.Url) {
      this.clipboardApi.copyFromContent(this.item.Url);
      this.showCopyMsg = true;
      this.msgService.add({ severity: 'success', summary: 'Document Link Copied', detail: 'Document Link Copied to Clipboard' });
    }
  }

  copyPropertiesLink() {
    if (this.item.IdT) {
      let host = window.location.origin;
      let rUrl = this.router.createUrlTree(['/props/', this.item.IdT]);
      let link = host + rUrl;
      this.clipboardApi.copyFromContent(link);
      this.showCopyMsg = true;
      this.msgService.add({ severity: 'success', summary: 'Document Properties Copied', detail: 'Document Properties Link Copied to Clipboard' });
    }
  }
}
